export const teamsCampaignList = {
    pagination: {
        defaultPageSize: 10,
        pageSizeOptions: [5, 10, 25],
        showFirstLastButtons: true,
        maxVisiblePages: 5
    }
};
